export default "__VITE_ASSET__D3qtGopf__"